// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Os$Showside from "./Os.bs.js";
import * as PerformanceObserver$Showside from "./PerformanceObserver.bs.js";
function useSafariHack(enabledOpt, callback, dependencies) {
  var enabled = enabledOpt !== undefined ? enabledOpt : false;
  PerformanceObserver$Showside.LegacyNavigationTiming.useLegacyNavigationTiming(enabled, function (param) {
    Curry._1(callback, param._type);
  }, dependencies);
}
var SafariHack = {
  useSafariHack: useSafariHack
};
function useBrowserNavigation(callback, dependencies) {
  var isSafari = Os$Showside.getBrowser(undefined) === /* Safari */1;
  useSafariHack(isSafari, callback, dependencies);
  PerformanceObserver$Showside.usePerformanceObserver1(!isSafari, true, /* Navigation */0, function (param) {
    Curry._1(callback, param._type);
  }, dependencies);
}
export { SafariHack, useBrowserNavigation };
/* PerformanceObserver-Showside Not a pure module */